import { useMutation } from "@apollo/client";

import { GqlSettingsEcologicalFunctionTypeObservationTypeLinkInput } from "~/__generated__";

import { SettingsObservationTypeEditRoute_AddFunctionTypeDocument } from "../mutations.generated";

export default function useSettingsObservationTypeEditRoute_AddFunctionType() {
    const [mutate, { loading, error }] = useMutation(SettingsObservationTypeEditRoute_AddFunctionTypeDocument);

    const addObservationTypeFunctionType = async (
        input: GqlSettingsEcologicalFunctionTypeObservationTypeLinkInput,
    ): Promise<void> => {
        await mutate({ variables: { input } });
    };

    return {
        addObservationTypeFunctionType,
        loading,
        error,
    };
}
